import React, { FC } from 'react';

export const AdminMenu: FC = () => {
  return <div></div>;
};
